<template>
  <span class="text-xs text-neutral-500">{{ message ?? defaultMessage }}</span>
</template>
<script setup lang="ts">
import { $t } from '@teachino/shared-i18n';

// Shown instead of a download/open-link button when Teachino is running
// inside an in-app WebView (e.g. the WebUntis mobile/tablet app): those
// WebViews swallow window.open()/target="_blank" and never trigger a real
// download, and there may be no other browser on the device to fall back to,
// so the only honest option is to explain that and point at opening Teachino
// in a browser.
defineProps<{
  message?: string;
}>();

const defaultMessage = $t('download.webview_not_possible');
</script>
